// -----------------------------
// グローバルな変数はここで定義しておく
// -----------------------------

// -----------------------------
// 関数群
// -----------------------------

// アコーディオンパネル
const setUpAccordion = () => {
  const details = document.querySelectorAll(".js-details");
  const isRunning = "running"; // アニメーション実行中のときに付与する予定のカスタムデータ属性の値
  const isOpend = "is-opened"; // アイコン操作用のクラス名

  details.forEach((element) => {
    const summary = element.querySelector(".js-summary");
    const content = element.querySelector(".js-content");

    summary.addEventListener("click", (event) => {
      event.preventDefault();
      if (element.dataset.animStatus === isRunning) {
        return;
      }
      if (element.open) {
        element.classList.toggle(isOpend);
        const closingAnim = content.animate(
          closingAnimKeyframes(content),
          animTiming
        );

        element.dataset.animStatus = isRunning;
        closingAnim.onfinish = () => {
          element.removeAttribute("open");
          element.dataset.animStatus = "";
        };
      } else {
        element.setAttribute("open", "true");
        element.classList.toggle(isOpend);

        const openingAnim = content.animate(
          openingAnimKeyframes(content),
          animTiming
        );
        element.dataset.animStatus = isRunning;
        openingAnim.onfinish = () => {
          element.dataset.animStatus = "";
        };
      }
    });
  });
};


/* アニメーションの時間とイージング */
const animTiming = {
  duration: 400,
  easing: "ease-out",
};

/*　アコーディオンを閉じるときのキーフレーム　*/
const closingAnimKeyframes = (content) => [
  {
    height: content.offsetHeight + "px",
    opacity: 1,
  },
  {
    height: 0,
    opacity: 0,
  },
];

/* アコーディオンを開くときのキーフレーム */
const openingAnimKeyframes = (content) => [
  {
    height: 0,
    opacity: 0,
  },
  {
    height: content.offsetHeight + "px",
    opacity: 1,
  },
];

// var toggleButtons = document.querySelectorAll('.js-toggle');
// toggleButtons.forEach(function(button) {
//   button.addEventListener('click', function() {
//     var targetId = button.dataset.target;
//     var content = document.getElementById(targetId);

//     if (content.style.height === '0px') {
//       var contentContainer = content.querySelector('.accordion-container');
//       var contentHeight = contentContainer.offsetHeight;

//       content.style.height = contentHeight + 'px';
//       content.scrollIntoView({ behavior: 'smooth' });

//       button.classList.add('is-opened'); // .is-opened クラスを追加
//     } else {
//       content.style.height = '0px';
//       button.classList.remove('is-opened'); // .is-opened クラスを削除
//     }
//   });
// });

// -----------------------------
// イベント系
// -----------------------------

// DOM読み込まれたら発火
window.addEventListener("DOMContentLoaded", function () {
  setUpAccordion();
});

// リサイズ時に発火
window.addEventListener("resize", function () {});

// スクロール時に発火
window.addEventListener("scroll", function () {});

// -----------------------------
// その他
// -----------------------------

//スクロールでアニメーションクラスを追加+コンテンツ内部で連番順にアニメーションクラスを追加
if (document.querySelector(".anm") != null) {
  const anm = document.querySelectorAll(".anm");
  const options = {
    root: null,
    rootMargin: "15%",
    threshold: [0.25],
  };

  const observe = new IntersectionObserver(addAnimation, options);
  anm.forEach(function (elem) {
    observe.observe(elem);
  });

  function addAnimation(entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-show");

        // data-anm-sub-start の値を取得（なければ 0）
        const startDelay = parseInt(entry.target.getAttribute("data-anm-sub-start") || "0", 10);

        // .anm 内の .anm-sub 要素を取得してソート
        const subElements = Array.from(entry.target.querySelectorAll(".anm-sub"));
        const sortedSubElements = subElements.sort((a, b) => {
          const numA = extractNumberFromClassName(a.className, "anm-sub");
          const numB = extractNumberFromClassName(b.className, "anm-sub");
          return numA - numB;
        });

        // 順番に .is-show を追加（0.3秒ずつ＋スタートディレイ）
        sortedSubElements.forEach((subElem, index) => {
          setTimeout(() => {
            subElem.classList.add("is-show");
          }, startDelay + index * 300);
        });
      } else {
        // entry.target.classList.remove("is-show");
        // const subElements = Array.from(entry.target.querySelectorAll(".anm-sub"));

        // const startDelay = parseInt(entry.target.getAttribute("data-anm-sub-start") || "0", 10);

        // // // クラス名から番号を抽出してソート
        // const sortedSubElements = subElements.sort((a, b) => {
        //   const numA = extractNumberFromClassName(a.className, "anm-sub");
        //   const numB = extractNumberFromClassName(b.className, "anm-sub");
        //   return numA - numB;
        // });

        // // // 順番に.is-showを削除
        // sortedSubElements.forEach((subElem, index) => {
        //   setTimeout(() => {
        //     subElem.classList.remove("is-show");
        //   }, index * 300);
        // });
      
      }
    });
  }

  function extractNumberFromClassName(className, prefix) {
    const regex = new RegExp(`${prefix}(\\d+)`);
    const match = className.match(regex);
    return match ? parseInt(match[1], 10) : 0;
  }
}
